<template>
  <div class="dashboard">
    <Breadcumb :title="$t('documention')" :breadcumb-data="breadcumbData"></Breadcumb>
    <div class="cardcontainer">
      <b-card no-body class="mb-2" v-for="(category, index) in categories">
        <b-card-header>
          <a v-if="$cookie.get('language') == 'fr'" class="text-body" href="javascript:void(0)" v-b-toggle="'accordion-' + index">{{category.label}}</a>
          <a v-else class="text-body" href="javascript:void(0)" v-b-toggle="'accordion-' + index">{{category.label_en}}</a>
        </b-card-header>
        <b-collapse :id="'accordion-'+index" visible accordion="accordion">
          <b-card-body>
            <div class="slick-container">
<!--              <slick-->
<!--                  ref="slick"-->
<!--                  :options="slickOptions"-->
<!--                  @afterChange="handleAfterChange"-->
<!--                  @beforeChange="handleBeforeChange"-->
<!--                  @breakpoint="handleBreakpoint"-->
<!--                  @destroy="handleDestroy"-->
<!--                  @edge="handleEdge"-->
<!--                  @init="handleInit"-->
<!--                  @reInit="handleReInit"-->
<!--                  @setPosition="handleSetPosition"-->
<!--                  @swipe="handleSwipe"-->
<!--                  @lazyLoaded="handleLazyLoaded"-->
<!--                  @lazyLoadError="handleLazeLoadError">-->
              <div class="row">
                <template v-for="document in category.documents">
                  <template v-if="document.user_types.includes(user.userprofile.user_type.id)">
                    <template v-if="$cookie.get('language') == 'fr' || ($cookie.get('language') == 'en' && document.label_en !== '')">
                      
                      <div class="col col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                      <b-card>
                        <b-card-header style="text-align:center;" v-if="$cookie.get('language') == 'fr'">
                          {{ document.label }}
                        </b-card-header>
                        <b-card-header style="text-align:center" v-else>
                          {{ document.label_en }}
                        </b-card-header>
                        <b-card-body style="text-align:center;">
                          <a>
                            <img style="width:auto; height:150px; display: inline-block;" v-bind:src="document.preview" alt="">
                          </a>
                        </b-card-body>
                        <b-card-footer style="text-align:center">
                          <b-btn v-bind:to="'/documentation/detail/' + document.id + '/'"  variant="primary">
                            <span v-if="document.filetype === 'document'">{{ $t('download_document')}}</span>
                            <span v-if="document.filetype === 'video'">{{ $t('read_video') }}</span>
                            <span v-if="document.filetype === 'article'">{{ $t('read_article')}}</span>
                          </b-btn>
                        </b-card-footer>
                      </b-card>
                      </div>
                    </template>
                  </template>
                </template>
              </div>
<!--              </slick>-->
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>
<style>
  .slick-arrow {
    color:#000000 !important;
    font-size:30px;
    heigh:30px;
    width:30px;
    z-index:99;
  }
  .slick-list{
    width:100%;
    margin-left:auto;
    margin-right:auto;
  }
  .slick-container{
    width:90%;
    margin-left:auto;
    margin-right:auto;
  }
  .text-body{
    font-size:1.2rem;
  }
</style>
<script>
  import Slick from 'vue-slick';
  import 'node_modules/slick-carousel/slick/slick.css';
  import 'node_modules/slick-carousel/slick/slick-theme.css';
  import { mapState } from 'vuex'
  import {
    GET_USER_DOCUMENTATION_REQUEST
  } from '../_store/documentation/actiontypes'
  import Breadcumb from '../components/breadcumb'

  export default {
    name: 'documentation',
    computed: mapState({
      categories: state => state.documentation.categories,
      user: state => state.user.user
    }),
    components: { Slick, Breadcumb, },
    mounted() {
      this.$store.dispatch(GET_USER_DOCUMENTATION_REQUEST)
      this.breadcumbData = [
        { text: this.$t('welcome'), href: '/dashboard/' },
        { text: this.$t('documention'), active: true},
      ]
    },
    data() {
      return {
        breadcumbData: [],
        filetype: '',
        slickOptions: {
          infinite: false,
          slidesToShow: 3,
          arrows: true,
          slidesToScroll: 1,
          adaptiveHeight: true,
          nextArrow: '<span class="slick-next"><i class="ion ion-ios-arrow-dropright-circle"></i></span>',
          prevArrow: '<span class="slick-prev"><i class="ion ion-ios-arrow-dropleft-circle"></i></span>'
        },
      };
    },
    layout(context) {
      return 'layout'
    },
    methods: {
      next() {
        this.$refs.slick.next();
      },

      prev() {
        this.$refs.slick.prev();
      },

      reInit() {
        // Helpful if you have to deal with v-for to update dynamic lists
        this.$nextTick(() => {
          this.$refs.slick.reSlick();
        });
      },

      // Events listeners
      handleAfterChange(event, slick, currentSlide) {
        console.log('handleAfterChange', event, slick, currentSlide);
      },
      handleBeforeChange(event, slick, currentSlide, nextSlide) {
        console.log('handleBeforeChange', event, slick, currentSlide, nextSlide);
      },
      handleBreakpoint(event, slick, breakpoint) {
        console.log('handleBreakpoint', event, slick, breakpoint);
      },
      handleDestroy(event, slick) {
        console.log('handleDestroy', event, slick);
      },
      handleEdge(event, slick, direction) {
        console.log('handleEdge', event, slick, direction);
      },
      handleInit(event, slick) {
        console.log('handleInit', event, slick);
      },
      handleReInit(event, slick) {
        console.log('handleReInit', event, slick);
      },
      handleSetPosition(event, slick) {
        console.log('handleSetPosition', event, slick);
      },
      handleSwipe(event, slick, direction) {
        console.log('handleSwipe', event, slick, direction);
      },
      handleLazyLoaded(event, slick, image, imageSource) {
        console.log('handleLazyLoaded', event, slick, image, imageSource);
      },
      handleLazeLoadError(event, slick, image, imageSource) {
        console.log('handleLazeLoadError', event, slick, image, imageSource);
      },

    }
  }
</script>
